export default __webpack_public_path__ + "static/media/48k.cccedc69.md";